var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Input, ViewChild } from '@angular/core';
import { finalize } from 'rxjs/operators';
import { ConfigureComponentBase } from '../../../../../shared/configure-component-base';
import { BatchEditAlarmModalComponent } from './batch-edit-alarm-modal/batch-edit-alarm-modal.component';
import { CreateOrEditAlarmModalComponent } from './create-or-edit-alarm-modal/create-or-edit-alarm-modal.component';
import { EnumAlarmLevel } from './enum-alarm-level';
import { AlarmGroupModalComponent } from './alarm-group-modal/alarm-group-modal.component';
import { AlarmDataSourceType } from '../shared/enum/alarm-data-source-type';
import { TriggerRuleType } from '../shared/enum/trigger-rule-type';
import { EnumChangeValue } from '../shared/enum/enum-change-value';
import { ConditionTypeHelper } from '../shared/condition-type-helper';
import { appModuleAnimation } from '../../../animations/routerTransition';
var AlarmRegistrationComponent = /** @class */ (function (_super) {
    __extends(AlarmRegistrationComponent, _super);
    function AlarmRegistrationComponent(injector, alarmRegistrationsService, dataTypeService, alarmGroupService, modalService) {
        var _this = _super.call(this, injector) || this;
        _this.injector = injector;
        _this.alarmRegistrationsService = alarmRegistrationsService;
        _this.dataTypeService = dataTypeService;
        _this.alarmGroupService = alarmGroupService;
        _this.modalService = modalService;
        _this.alarmLevel = EnumAlarmLevel;
        _this.selectedAlarms = [];
        _this.alarmLevelsData = _this.getEnum(EnumAlarmLevel);
        return _this;
    }
    Object.defineProperty(AlarmRegistrationComponent.prototype, "selectedAlarmIds", {
        get: function () {
            if (!this.selectedAlarms || this.selectedAlarms.length === 0) {
                return [];
            }
            return this.selectedAlarms.map(function (x) { return x.id; });
        },
        enumerable: true,
        configurable: true
    });
    AlarmRegistrationComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.reloadDataAction = function () { return _this.onDataSourceChanged(); };
        abp.event.on('dataSource.add', function () { return _this.reloadDataAction(); });
        abp.event.on('dataSource.rename', function () { return _this.reloadDataAction(); });
        abp.event.on('dataSource.delete', function () { return _this.reloadDataAction(); });
        this.alarmDataSourceTypes = [{ name: this.lc('Variable'), key: AlarmDataSourceType.Variable },
            { name: this.getFBoxAlias(), key: AlarmDataSourceType.FBox }];
    };
    AlarmRegistrationComponent.prototype.ngOnDestroy = function () {
        abp.event.off('dataSource.add', null);
        abp.event.off('dataSource.rename', null);
        abp.event.off('dataSource.delete', null);
    };
    // 初始化/数据源修改、删除、新增用
    AlarmRegistrationComponent.prototype.onDataSourceChanged = function (event) {
        this.loadAlarmDefs(event);
        this.loadGroups();
    };
    AlarmRegistrationComponent.prototype.formatAlarmLevel = function (alarmLevel) {
        switch (alarmLevel) {
            case 0:
                return this.lc('AlarmWarning');
            case 1:
                return this.lc('AlarmMinor');
            case 2:
                return this.lc('AlarmMajor');
            case 3:
                return this.lc('AlarmCritical');
            default:
                return this.lc('AlarmWarning');
        }
    };
    AlarmRegistrationComponent.prototype.formatAlarmDataSource = function (alarmDataSource) {
        if (alarmDataSource === AlarmDataSourceType.FBox) {
            return this.getFBoxAlias();
        }
        else {
            return this.lc('Variable');
        }
    };
    AlarmRegistrationComponent.prototype.formatTriggerRule = function (result) {
        if (+result.alarmDataSource === AlarmDataSourceType.FBox) {
            if (result.refAlarmDto) {
                return this.getTriggerRuleFromFBox(result.refAlarmDto);
            }
            return '';
        }
        if (!result.triggerRuleType && result.triggerRuleType !== 0) {
            return '';
        }
        switch (+result.triggerRuleType) {
            case TriggerRuleType.Threshold: // 阀值
                return this.getTriggerRuleFromVariable(result.triggerRuleValue.threshold, +result.variableDataType);
            case TriggerRuleType.Deviance: // 偏差
                return "" + this.lc('DevianceValue') + result.triggerRuleValue.deviance.value + "," + this.lc('TargetValue') + result.triggerRuleValue.deviance.targetValue;
            case TriggerRuleType.ChangeRate: // 变化率
                return "" + this.lc('ChangeRate') + result.triggerRuleValue.changeRate.changeRate + "," + result.triggerRuleValue.changeRate.cycle + "s";
            case TriggerRuleType.Change: // 值变化
                return this.getChangeValue(+result.triggerRuleValue.value);
            default:
                return '';
        }
    };
    AlarmRegistrationComponent.prototype.getChangeValue = function (value) {
        switch (+value) {
            case EnumChangeValue.Value0:
                return this.lc('Value0');
            case EnumChangeValue.Value1:
                return this.lc('Value1');
            case EnumChangeValue.Change:
                return this.lc('ValueChange');
            default:
                return '';
        }
    };
    AlarmRegistrationComponent.prototype.getTriggerRuleFromFBox = function (refAlarm) {
        return this.getTriggerRule({
            dataType: refAlarm.dataType,
            bitIndexEnabled: refAlarm.bitIndexEnabled,
            operand1: refAlarm.operand1,
            operand2: refAlarm.operand2,
            conditionCombineMethod: refAlarm.conditionCombineMethod,
            condition1: refAlarm.condition1,
            condition2: refAlarm.condition2
        });
    };
    AlarmRegistrationComponent.prototype.getTriggerRuleFromVariable = function (threshold, dataType) {
        return this.getTriggerRule({
            dataType: dataType,
            operand1: threshold.operand1,
            operand2: threshold.operand2,
            conditionCombineMethod: threshold.conditionCombine,
            condition1: threshold.condition1,
            condition2: threshold.condition2
        });
    };
    AlarmRegistrationComponent.prototype.getTriggerRule = function (triggerRule) {
        var isBit = false;
        if (triggerRule.dataType === 0 || triggerRule.bitIndexEnabled) {
            isBit = true;
        }
        if (isBit && triggerRule.operand1 === 0) {
            return 'OFF';
        }
        if (isBit && triggerRule.operand1 === 1) {
            return 'ON';
        }
        if (!isBit) {
            switch (triggerRule.conditionCombineMethod) {
                case 0:
                    return this.lc('Value') + ' ' + this.lc(ConditionTypeHelper.getAlarmConditionName(triggerRule.condition1)) + triggerRule.operand1;
                case 1:
                    return this.lc('Value') + ' ' + this.lc(ConditionTypeHelper.getAlarmConditionName(triggerRule.condition1)) +
                        triggerRule.operand1 + this.lc('And') + this.lc(ConditionTypeHelper.getAlarmConditionName(triggerRule.condition2)) + triggerRule.operand2;
                case 2:
                    return this.lc('Value') + ' ' + this.lc(ConditionTypeHelper.getAlarmConditionName(triggerRule.condition1)) +
                        triggerRule.operand1 + this.lc('Or') + this.lc(ConditionTypeHelper.getAlarmConditionName(triggerRule.condition2)) + triggerRule.operand2;
            }
        }
    };
    // 新增完成事件
    AlarmRegistrationComponent.prototype.createComplete = function () {
        this.loadAlarmDefs();
    };
    // 编辑报警完成事件
    AlarmRegistrationComponent.prototype.updateComplete = function () {
        this.loadAlarmDefs(this.lazyLoadEvent);
    };
    // 批量修改等级完成事件
    AlarmRegistrationComponent.prototype.loadAlarmDefsAndRemoveAllSelected = function () {
        this.selectedAlarms = [];
        this.loadAlarmDefs();
    };
    // 获取告警数据
    AlarmRegistrationComponent.prototype.loadAlarmDefs = function (event) {
        var _this = this;
        if (!this.configureId) {
            return;
        }
        this.lazyLoadEvent = event;
        if (this.primengTableHelper.shouldResetPaging(event)) {
            this.paginator.changePage(0);
            return;
        }
        if (!this.selectedGroupId) {
            this.selectedGroupId = undefined;
        }
        if (!this.selectedAlarmDataSource && this.selectedAlarmDataSource !== 0) {
            this.selectedAlarmDataSource = undefined;
        }
        if (!this.selectedAlarmLevel && this.selectedAlarmLevel !== 0) {
            this.selectedAlarmLevel = undefined;
        }
        this.primengTableHelper.showDelayLoadingIndicator();
        this.alarmRegistrationsService.getConfigureAlarms(this.configureId, this.selectedAlarmDataSource && this.selectedAlarmDataSource, this.selectedAlarmLevel && this.selectedAlarmLevel, this.selectedGroupId, this.alarmSearchCriteria, this.primengTableHelper.getSorting(this.dataTable), this.primengTableHelper.getMaxResultCount(this.paginator, event), this.primengTableHelper.getSkipCount(this.paginator, event)).pipe(finalize(function () { return _this.primengTableHelper.hideLoadingIndicator(); }))
            .subscribe(function (result) {
            _this.primengTableHelper.requestCompleted = true;
            _this.primengTableHelper.totalRecordsCount = result.totalCount;
            _this.primengTableHelper.records = result.items;
            if (_this.lazyLoadEvent && result.totalCount && (!result.items || result.items.length === 0)) {
                var jumpToPage = ~~((result.totalCount - 1) / _this.paginator.rows);
                _this.paginator.changePage(jumpToPage);
            }
            _this.primengTableHelper.hideLoadingIndicator();
        });
    };
    // 单个删除报警数据
    AlarmRegistrationComponent.prototype.singleDeleteAlarm = function (id) {
        var _this = this;
        this.message.confirm(this.lc('AlarmDeleteWarningMessage'), this.l('AreYouSure'), function (isConfirmed) {
            if (isConfirmed) {
                _this.primengTableHelper.showDelayLoadingIndicator();
                _this.alarmRegistrationsService.deleteConfigureAlarm([id])
                    .pipe(finalize(function () { return _this.primengTableHelper.hideLoadingIndicator(); }))
                    .subscribe(function () {
                    _this.selectedAlarms = _this.selectedAlarms.filter(function (alarm) { return alarm.id !== id; });
                    // 删除成功提示
                    _this.primengTableHelper.hideLoadingIndicator();
                    abp.notify.success(_this.l('SuccessfullyDeleted'));
                    _this.loadAlarmDefs(_this.lazyLoadEvent);
                });
            }
        });
    };
    // 批量删除报警数据
    AlarmRegistrationComponent.prototype.batchDeleteAlarms = function () {
        var _this = this;
        this.message.confirm(this.lc('AlarmDeleteWarningMessage'), this.l('AreYouSure'), function (isConfirmed) {
            if (isConfirmed) {
                _this.primengTableHelper.showDelayLoadingIndicator();
                _this.alarmRegistrationsService.deleteConfigureAlarm(_this.selectedAlarmIds)
                    .pipe(finalize(function () { return _this.primengTableHelper.hideLoadingIndicator(); }))
                    .subscribe(function () {
                    // 删除成功提示
                    _this.primengTableHelper.hideLoadingIndicator();
                    abp.notify.success(_this.l('SuccessfullyDeleted'));
                    _this.selectedAlarms = [];
                    _this.loadAlarmDefs();
                });
            }
        });
    };
    // 显示添加模态框
    AlarmRegistrationComponent.prototype.showAddComponent = function () {
        var _this = this;
        var modalRef = this.modalService.show(CreateOrEditAlarmModalComponent, {
            initialState: {
                configureId: this.configureId,
            },
            backdrop: 'static',
            class: 'create-or-update-alarm-modal'
        });
        modalRef.content.createdEvent.subscribe(function () {
            _this.createComplete();
        });
    };
    // 显示修改模态框
    AlarmRegistrationComponent.prototype.showEditComponent = function (id) {
        var _this = this;
        var modalRef = this.modalService.show(CreateOrEditAlarmModalComponent, {
            initialState: {
                configureId: this.configureId,
                alarmId: id
            },
            backdrop: 'static',
            class: 'create-or-update-alarm-modal'
        });
        modalRef.content.updatedEvent.subscribe(function () {
            _this.updateComplete();
        });
    };
    // 显示批量导入模态框
    AlarmRegistrationComponent.prototype.showBatchImportModal = function () {
        this.batchImportAlarmModalComponent.show();
    };
    // 显示批量修改报警等级模态框
    AlarmRegistrationComponent.prototype.showBatchModifyLevelModal = function () {
        var _this = this;
        var modalRef = this.modalService.show(BatchEditAlarmModalComponent, {
            initialState: {
                configureId: this.configureId,
                selectedIds: this.selectedAlarmIds,
            },
            backdrop: 'static'
        });
        modalRef.content.refreshData.subscribe(function () {
            _this.loadAlarmDefsAndRemoveAllSelected();
        });
    };
    AlarmRegistrationComponent.prototype.formatDataType = function (dataType, bitIndexEnabled) {
        var _this = this;
        return this.dataTypeService.formatDataType(dataType, bitIndexEnabled, function (key) {
            var args = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args[_i - 1] = arguments[_i];
            }
            return _this.lc.apply(_this, [key].concat(args));
        });
    };
    AlarmRegistrationComponent.prototype.loadGroups = function () {
        var _this = this;
        this.alarmGroupService.getAlarmGroups(this.configureId)
            .subscribe(function (result) {
            _this.groupList = result;
        });
    };
    AlarmRegistrationComponent.prototype.loadAlarmsAndGroupOnCurrentPage = function () {
        this.loadGroups();
        this.loadAlarmDefs(this.lazyLoadEvent);
    };
    AlarmRegistrationComponent.prototype.loadAlarmsAndClearSelectedItems = function () {
        this.selectedAlarms = [];
        this.loadAlarmDefs();
    };
    AlarmRegistrationComponent.prototype.loadAlarmAndGroup = function (deletedIds) {
        if (this.selectedAlarms && deletedIds.length > 0) {
            this.selectedAlarms = this.selectedAlarms.filter(function (x) { return deletedIds.findIndex(function (id) { return id === x.id; }) === -1; });
        }
        this.loadGroups();
        this.loadAlarmDefs();
    };
    AlarmRegistrationComponent.prototype.showAlarmGroupModal = function () {
        var _this = this;
        var modalRef = this.modalService.show(AlarmGroupModalComponent, {
            initialState: {
                configureId: this.configureId
            },
            backdrop: 'static'
        });
        modalRef.content.groupSavedEvent.subscribe(function () {
            _this.loadGroups();
        });
        modalRef.content.groupEditedEvent.subscribe(function () {
            _this.loadAlarmsAndGroupOnCurrentPage();
        });
        modalRef.content.groupDeletedEvent.subscribe(function (result) {
            _this.loadAlarmAndGroup(result);
        });
    };
    AlarmRegistrationComponent.prototype.getEnum = function (enumType) {
        var myEnum = [];
        var objectEnum = Object.keys(enumType);
        var values = objectEnum.slice(0, objectEnum.length / 2);
        var keys = objectEnum.slice(objectEnum.length / 2);
        for (var i = 0; i < objectEnum.length / 2; i++) {
            myEnum.push({ key: keys[i], value: +values[i] });
        }
        return myEnum;
    };
    __decorate([
        Input()
    ], AlarmRegistrationComponent.prototype, "configureId", void 0);
    __decorate([
        ViewChild('dataTable', { static: true })
    ], AlarmRegistrationComponent.prototype, "dataTable", void 0);
    __decorate([
        ViewChild('paginator', { static: false })
    ], AlarmRegistrationComponent.prototype, "paginator", void 0);
    __decorate([
        ViewChild('batchImportAlarmModalComponent', { static: false })
    ], AlarmRegistrationComponent.prototype, "batchImportAlarmModalComponent", void 0);
    AlarmRegistrationComponent = __decorate([
        Component({
            selector: 'alarm-registration',
            template: "<div class=\"portlet-input designer-registretion\"> <div class=\"row alarm-registeration-operation\"> <div class=\"col-lg-12 operation-filter\"> <div class=\"col-lg-2 operation-filter-select\"> <ng-select name=\"alarmDataSource\" [items]=\"alarmDataSourceTypes\" bindLabel=\"name\" bindValue=\"key\" [searchable]=\"true\" [placeholder]=\"lc('AllAlarmSource')\" [(ngModel)]=\"selectedAlarmDataSource\" [clearable]=\"true\" (change)=\"loadAlarmDefsAndRemoveAllSelected()\" [notFoundText]=\"l('NoData')\"> <ng-template ng-option-tmp ng-label-tmp let-item=\"item\"> {{item.name}} </ng-template> </ng-select> </div> <div class=\"col-lg-2 operation-filter-select\"> <ng-select name=\"alarmLevel\" [items]=\"alarmLevelsData\" bindLabel=\"key\" bindValue=\"value\" [searchable]=\"true\" [placeholder]=\"lc('AllAlarmLevel')\" [(ngModel)]=\"selectedAlarmLevel\" [clearable]=\"true\" (change)=\"loadAlarmDefsAndRemoveAllSelected()\" [notFoundText]=\"l('NoData')\"> <ng-template ng-option-tmp ng-label-tmp let-item=\"item\"> {{lc(item.key)}} </ng-template> </ng-select> </div> <div class=\"col-lg-2 operation-filter-select\"> <ng-select name=\"groupSelect\" [items]=\"groupList\" bindLabel=\"name\" bindValue=\"id\" [searchable]=\"true\" [placeholder]=\"lc('AllAlarmGroup')\" [(ngModel)]=\"selectedGroupId\" [clearable]=\"true\" (change)=\"loadAlarmsAndClearSelectedItems()\" [notFoundText]=\"l('NoData')\"> <ng-template ng-option-tmp ng-label-tmp let-item=\"item\"> {{item.name}} </ng-template> </ng-select> </div> </div> </div> <div class=\"row alarm-registeration-operation\"> <div class=\"col-lg-6 operation-button\"> <button class=\"fe-btn fe-btn-default fe-btn-save\" (click)=\"showAddComponent()\">{{lc('AddAlarm')}}</button> <button class=\"fe-btn fe-btn-default fe-btn-save\" (click)=\"showBatchImportModal()\">{{lc('ImportAlarm')}}</button> <button class=\"fe-btn fe-btn-default btn-batch-delete\" [disabled]=\"!selectedAlarms || selectedAlarms.length === 0\" (click)=\"showBatchModifyLevelModal()\">{{lc('BatchEdit')}}</button> <button class=\"fe-btn fe-btn-default btn-batch-delete\" [disabled]=\"!selectedAlarms || selectedAlarms.length === 0\" (click)=\"batchDeleteAlarms()\">{{lc('BatchDelete')}}</button> <button class=\"fe-btn fe-btn-default fe-btn-normal\" (click)=\"showAlarmGroupModal()\">{{lc('AlarmGroupManage')}}</button> </div> <div class=\"col-lg-6 operation-filter\"> <div class=\"operation-search\"> <input class=\"operation-search-input\" placeholder='{{lc(\"AlarmSearchCriteria\")}}' type=\"text\" name=\"alarmSearchCriteria\" (change)=\"loadAlarmDefsAndRemoveAllSelected()\" [(ngModel)]=\"alarmSearchCriteria\"> <i class=\"fcloud-search\"></i> </div> </div> </div> </div> <div class=\"primeng-datatable-container designer-actions-style\" [busyIf]=\"primengTableHelper.isLoading\"> <p-table #dataTable (onLazyLoad)=\"onDataSourceChanged($event)\" [value]=\"primengTableHelper.records\" rows=\"{{primengTableHelper.defaultRecordsCountPerPage}}\" [paginator]=\"false\" [lazy]=\"true\" selectionMode=\"multiple\" [(selection)]=\"selectedAlarms\" scrollable=\"true\" dataKey=\"id\" ScrollWidth=\"100%\" responsive=\"primengTableHelper.isResponsive\" resizableColumns=\"primengTableHelper.resizableColumns\"> <ng-template pTemplate=\"header\"> <tr> <th class=\"checkbox\" style=\"width: 50px;\"> <p-tableHeaderCheckbox></p-tableHeaderCheckbox> </th> <th style=\"width: 100px\"> {{lc('AlarmNameG')}} </th> <th style=\"width: 150px\"> {{lc('AlarmMessage')}} </th> <th style=\"width: 100px\"> {{lc('AlarmDataSource')}} </th> <th style=\"width: 100px\"> {{lc('DataSourceName')}} </th> <th style=\"width: 100px\"> {{lc('AlarmLevel')}} </th> <th style=\"width: 100px\"> {{lc('MalfunctionCode')}} </th> <th style=\"width: 100px\"> {{lc('AlarmGroup')}} </th> <th style=\"width: 200px\"> {{lc('TriggerRule')}} </th> <th style=\"width: 100px\"> {{lc('ConfigureVariableName')}} </th> <th style=\"width: 100px\"> {{getFBoxAlias()}}{{lc('AlarmNameG')}} </th> <th style=\"width: 100px\" class=\"last-th\"> {{l('Actions')}} <span class=\"fa fa-cog fa-fw\"></span> </th> </tr> </ng-template> <ng-template pTemplate=\"body\" let-record> <tr [pSelectableRow]=\"record\"> <td class=\"checkbox\" style=\"width: 50px;\"> <p-tableCheckbox [value]=\"record\"></p-tableCheckbox> </td> <td style=\"width: 100px\"> {{record.name}} </td> <td style=\"width: 150px\"> {{record.alarmMessage}} </td> <td style=\"width: 100px\"> {{formatAlarmDataSource(record.alarmDataSource)}} </td> <td style=\"width: 100px\"> {{record.alarmDataSource > 0 ? record.dataSourceName : '-'}} </td> <td style=\"width: 100px\"> <div *ngIf=\"+record.alarmLevel === +alarmLevel.AlarmWarning\" class=\"level-content level-one\"> <div class=\"level-color\"></div> <div>{{formatAlarmLevel(record.alarmLevel)}}</div> </div> <div *ngIf=\"+record.alarmLevel === +alarmLevel.AlarmMinor\" class=\"level-content level-two\"> <div class=\"level-color\"></div> <div>{{formatAlarmLevel(record.alarmLevel)}}</div> </div> <div *ngIf=\"+record.alarmLevel === +alarmLevel.AlarmMajor\" class=\"level-content level-three\"> <div class=\"level-color\"></div> <div>{{formatAlarmLevel(record.alarmLevel)}}</div> </div> <div *ngIf=\"+record.alarmLevel === +alarmLevel.AlarmCritical\" class=\"level-content level-four\"> <div class=\"level-color\"></div> <div>{{formatAlarmLevel(record.alarmLevel)}}</div> </div> </td> <td style=\"width: 100px\"> {{record.faultCode}} </td> <td style=\"width: 100px\"> {{record.groupName}} </td> <td style=\"width: 200px\"> {{formatTriggerRule(record)}} </td> <td style=\"width: 100px\"> {{record.variableName}} </td> <td style=\"width: 100px\"> {{record.refAlarmDefName}} </td> <td style=\"width: 100px\" class=\"operation\"> <a (click)=\"showEditComponent(record.id)\" style=\"padding-left: 10px\">{{l('Edit')}}</a> <a (click)=\"singleDeleteAlarm(record.id)\" style=\"padding-left: 10px\">{{l('Delete')}}</a> </td> </tr> </ng-template> </p-table> <div class=\"primeng-no-data\" *ngIf=\"primengTableHelper.totalRecordsCount == 0\"> {{l('NoData')}} </div> <div class=\"primeng-paging-container\"> <p-paginator [rows]=\"primengTableHelper.defaultRecordsCountPerPage\" #paginator (onPageChange)=\"loadAlarmDefs($event)\" [totalRecords]=\"primengTableHelper.totalRecordsCount\" [rowsPerPageOptions]=\"primengTableHelper.predefinedRecordsCountPerPage\"> </p-paginator> <span class=\"total-records-count\"> {{l('TotalRecordsCount', primengTableHelper.totalRecordsCount)}} </span> </div> </div> <batch-import-alarm-modal #batchImportAlarmModalComponent [configureId]=\"configureId\" (reFreshData)=\"loadAlarmDefs()\"> </batch-import-alarm-modal> ",
            styles: [".designer-registretion{ .last-th { text-align: right !important; span { padding-right: 0; display: inline-block; } } .design-content .variable-transverse .variable-title { width: 23%; line-height: 30px; text-align: right; padding-right: 20px; } .variable-transverse .variable-input { width: 38%; } .alarm-search { margin-bottom: 10px; } .input-group { .form-control { padding-right: 16px; } .var-form-control { height: 34px; padding: 0 2rem 0 1.25rem; } .form-control-search { position: absolute; z-index: 4; right: 10px; display: block; width: 16px; height: 16px; line-height: 34px; text-align: center; pointer-events: none; color: #aaa; } } .operation { text-align: right !important; a { color: #3695FF !important; } a:hover { cursor: pointer; } a:first-child { margin-right: 10px; } } .alarm-registeration-operation { .operation-filter-select { padding: 0; } .operation-button { padding: 0; button { margin-bottom: 12px; } } .operation-search { float: right; position: relative; width:285px; input::-webkit-input-placeholder { color: rgba(0, 0, 0, 0.6); } input::-moz-placeholder { /* Mozilla Firefox 19+ */ color: rgba(0, 0, 0, 0.6); } input:-moz-placeholder { /* Mozilla Firefox 4 to 18 */ color: rgba(0, 0, 0, 0.6); } input:-ms-input-placeholder { /* Internet Explorer 10-11 */ color: rgba(0, 0, 0, 0.6); } } .fcloud-search { position: absolute; right: 10px; top: 9px; font-size: 16px; cursor: pointer; } .operation-search-input { width: 100%; height: 34px; border: 1px solid #C4C6CF; color: rgba(0, 0, 0, 0.6); line-height: 34px; padding: 0 10px; margin-bottom: 12px; padding-left: 10px; padding-right: 34px; } .operation-filter { padding: 0; .operation-filter-select { float: left; margin-right: 12px; margin-bottom: 12px; } } .fe-btn:not(:last-child) { margin-right: 12px; } } select option { color: rgba(0, 0, 0, 0.6); } .fe-btn.fe-btn-default.btn-batch-delete { color: #000; background-color: #FFF; border: 1px solid #C4C6CF; } .fe-btn.fe-btn-default.fe-btn-normal { border: 1px solid #b5c2ca; background-color: white; } .fe-btn.fe-btn-default.btn-batch-delete:disabled { color: #7F939F; border: 1px solid #b5c2ca; } .alarm-registeration-operation > div { float: left; } .alarm-registeration-operation { margin-left: 0; margin-right: 0; } @media (max-width: 1425px) { .alarm-registeration-operation { .operation-button, .operation-filter { width: 100%; } } } .level-color { width: 16px; height: 16px; margin-right: 8px; } .level-content { display: flex; align-items: center; justify-content: flex-start; } .level-one { .level-color { background-color: #3695FF; } } .level-two { .level-color { background-color: #FFE900; } } .level-three { .level-color { background-color: #FFA800; } } .level-four { .level-color { background-color: #E84F4F; } } .checkbox { width: 50px; } .operation-filter-select ::ng-deep .ng-select-container { height: 34px !important; border: 1px solid #C4C6CF; } .ng-select.ng-select-single .ng-select-container { height: 34px; } }"],
            animations: [appModuleAnimation()]
        })
    ], AlarmRegistrationComponent);
    return AlarmRegistrationComponent;
}(ConfigureComponentBase));
export { AlarmRegistrationComponent };
